export default __webpack_public_path__ + "static/media/job5.16f77e87.svg";